import { Component, ElementRef, ViewChild, OnInit } from '@angular/core';
import { PageBase, RentalObjectInfo } from 't4core';
import { CreateServiceRequestDialog } from '../../../../t4common';

@Component({
  styleUrls: ['./TrailerInspections.css'],
  selector: 'TrailerInspections',
  templateUrl: './TrailerInspections.html',
})
export class TrailerInspectionsComponent extends PageBase implements OnInit {

    public inspections: RentalObjectInfo[];
    private _from: moment.Moment = this.now.clone();
    private _to: moment.Moment = this.now.clone();
    public queryParameters: any = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };

    @ViewChild('tbl', { static: false }) private tbl: any;

    public selectedRows: any[] = [];

    public get selectedCount(): number { return this.selectedRows.length; }

    public get from(): moment.Moment { return this._from; }
    public set from(val: moment.Moment) {
        if (this._from != val) {
            this._from = val;
            this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
        }
    }

    public get to(): moment.Moment { return this._to; }
    public set to(val: moment.Moment) {
        if (this._to != val) {
            this._to = val;
            this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
        }
    }
    constructor(el: ElementRef) {
        super(el, "Service");
    }

    async ngOnInit() {
        await this.loadInspections();
    }

    public async loadInspections() {
      const res = await this.Api.get<RentalObjectInfo[]>("RentalObject/GetGermanyRentalObjects");
      this.inspections = res || [];

      for (const r of this.inspections) {
        (r as any)._selected = false;
      }

        console.log("inspections (rental objects from Germany)", this.inspections);
    }
    public updateParams() {
        this.queryParameters = { from: this._from.format("YYYY-MM-DDTHH:mm:ss[Z]"), to: this._to.format("YYYY-MM-DDTHH:mm:ss[Z]") };
    }

    public onRowSelected(row: any, checked: boolean) {
        row._selected = checked;

        if (checked) {
            if (!this.selectedRows.find(x => x === row)) this.selectedRows.push(row);
        } else {
            const idx = this.selectedRows.findIndex(x => x === row);
            if (idx >= 0) this.selectedRows.splice(idx, 1);
        }
    }
  public async createServiceRequests() {
    if (this.selectedRows.length === 0) return;

    // Open the create service request dialog in bulk mode and pass an origin marker
    const dlg = this.Dialog.open(CreateServiceRequestDialog, {
      maxHeight: 'calc(100vh - 20px)',
      maxWidth: 'calc(100vw - 20px)',
      data: {
        origin: 'TrailerInspections',
        rentalObjects: this.selectedRows,
        rentalLocation: this.Settings.clientSettings.RentalLocationId
      }
    });

    // Optionally wait for result
    const result = await dlg.afterClosed().toPromise();
    if (result) {
      // handle any returned data (e.g. refresh)
      await this.loadInspections();
      if (this.tbl && this.tbl.update) this.tbl.update();
    }
  }
}
